/*
This file should only contain the code for the plugin, not any specific instance of it being used. Please put your code for swapBackground in the file for the component/widget you are swapping the background of. Ex. if you need to swap the background of the main site hero banner, put the swapBackground code for that in widgets/_hero.js 
USAGE:
import swapBackground from '~/utils/swapBackground'
swapBackground('.thingToSwap', {
	mediaQuery: 991,
})
PUG:
	.background(data-bgSm="//via.placeholder.com/300x700", data-bgLg="//via.placeholder.com/900x1400")

	-or-
	//you HAVE to use a back tick (``), not a single quote ('') or a double quote ("") if you are using the multi version. Single and double quotes will break with the multiple line white space. There is no limit to how many backgrounds you can specify. The numbers are screen sizes, so it will show the corresponding background image form that size up, until it the next largest size matches the screen size
	.background(data-bgMulti=`
		0: //via.placeholder.com/200x300,
		300: //via.placeholder.com/300x700,
		700: //via.placeholder.com/400x1100,
		1100: //via.placeholder.com/450x1400,
		1400: //via.placeholder.com/600x1900
	`)
*/
import { util } from '~/core';
import merge from '~/utils/merge'

export default function swapBackground(ele, opts) {
	const elements = typeof ele == 'string' ? [...document.querySelectorAll(ele)] : ele.length ? [...ele] : [ele]
	elements.forEach(element => {
		const defaults = {
			srcSm: element.getAttribute('data-bgSm') || '',
			srcLg: element.getAttribute('data-bgLg') || '',
			srcMulti: element.getAttribute('data-bgMulti') || false,
			mediaQuery: 1023
		}
		const options = merge(defaults, opts)
		let src = {}
		let media = []

		const swapImages = () => {
			media.forEach(query => {
				if (query.value.matches) {
					element.style.backgroundImage = `url(${src[query.key]})`
				}
			})
		}

		if (options.srcMulti) {
			src = JSON.parse(options.srcMulti)
		}
		else {
			src[0] = options.srcSm
			src[options.mediaQuery] = options.srcLg
		}

		for (let key in src) {
			media.push({ key: parseInt(key), value: window.matchMedia(`(min-width:${key}px)`) })
		}
		media.sort((a, b) => a.key - b.key)

		media.forEach(query => {
			query.value.addListener(swapImages)
		})
		swapImages()
	})
}

util.swapBackground = swapBackground